module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10241.0e268b86.jpg";